import { useContext } from 'react';

import { HideModeContext } from '@components/Providers/HideModeProvider';

export const useHideMode = () => {
  return useContext(HideModeContext);
};
